import {panel, colors} from '@xpertdox_js/xdstyle';

export default {
  container: {
    background: colors.offWhite,
    height: '89%',
    // height: '708px',
    overflowY: 'scroll',
    fontSize: '1.2rem',
    padding: '12px 8px'
  },
  property: {
    margin: '0 0 8px',
    fontSize: '1.4rem',
    fontWeight: 'bold',
    color: colors.black,
  },
  value: {
    margin: '0 0 18px',
    fontSize: '1.36rem',
    color: 'rgb(85, 85, 85)',
  },
  list: {
    paddingLeft: '16px',
  },
  listItem: {
    paddingLeft: 0,
  }
}
